import { Getters } from 'vuex-smart-module';
import OrdersInvoicesState from './state';

export default class OrdersInvoicesGetters extends Getters<OrdersInvoicesState> {
}
